import React from "react"

export default function Footer(props) {
  return (
      <footer id="main-footer">
        <p>Copyright Yagmin Properties LLC</p>
      </footer>
  )
}
